export default class BlockObserver {
	constructor(blocks) {

		this.blocks 				= blocks;
		this.blockObserver 			= null
		this.isIntersecting 		= this.isIntersecting.bind(this)
		this.init 					= this.init.bind(this)

		// window.emitter.on('pageReady', this.init)

	}

	init() {

		// console.log('Initialized blockObserver')

		this.blockObserver = new IntersectionObserver(this.isIntersecting, {
			root: null, // Use the viewport as the root
			rootMargin: "-200px 0px 50px 0px", // No additional margin
			threshold: 0, // Trigger when 0 of the video is visible
		})

		this.blocks && this.blocks.forEach( (block) => {
			// Start observing the block element
			this.blockObserver.observe(block)
		})

	}

	isIntersecting(entries) {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				
				entry.target.classList.add("visible");

			}
		})
	}

}
